export const login_logo = {
  alt: 'nasacademy login',
  mobileImgData: {
    src: 'https://d2oi1rqwb0pj00.cloudfront.net/na-website/svg/na-black.svg',
    webpSrc:
      'https://d2oi1rqwb0pj00.cloudfront.net/na-website/svg/na-black.svg',
  },
};

export const loginBackground = {
  alt: 'login background',
  mobileImgData: {
    src:
      'https://d2oi1rqwb0pj00.cloudfront.net/na-portal/HomePage/login_bg.png',
    webpSrc:
      'https://d2oi1rqwb0pj00.cloudfront.net/na-portal/HomePage/login_bg.webp',
  },
};
